import React from 'react';
import { Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';

const CustomTooltip = props => {
  const { t } = useTranslation();

  if (props && props.payload && props.payload[0] != null) {
    let newPayload = [
      ...props.payload,
      ...(props.hiddenSeries &&
        props.hiddenSeries
          .map(({ dataKey, index, color }) => {
            const value = props.payload[index].payload[dataKey];
            return value
              ? {
                  name: dataKey,
                  value,
                  color,
                }
              : null;
          })
          .filter(Boolean)),
    ];

    // Special handling for casAverageWages chart
    if (props.id === 'casAverageWages') {
      // Get the current data point
      const currentDataPoint = props.payload[0].payload;

      // Define the desired order for casAverageWages
      const desiredOrder = ['companyAverageWage', 'averageMale', 'averageFemale', 'sectorAverageWage'];

      // Create a map of series by dataKey for easy lookup
      const seriesMap = {};
      props.series.forEach(series => {
        seriesMap[series.dataKey] = series;
      });

      // Create payload in the desired order
      newPayload = desiredOrder
        .map(dataKey => {
          const series = seriesMap[dataKey];
          if (series) {
            const value = currentDataPoint[dataKey];
            return {
              name: dataKey,
              value: value !== undefined && value !== null ? value : '-',
              color: series.fill ?? series.stroke ?? series.color,
            };
          }
          return null;
        })
        .filter(Boolean); // Remove nulls for non-existent series

      // Add hidden series if they exist (in original order)
      if (props.hiddenSeries) {
        const hiddenPayload = props.hiddenSeries.map(({ dataKey, color }) => {
          const value = currentDataPoint[dataKey];
          return {
            name: dataKey,
            value: value !== undefined && value !== null ? value : '-',
            color,
          };
        });
        newPayload = [...newPayload, ...hiddenPayload];
      }
    }

    return (
      <div className="recharts-default-tooltip">
        <Row>
          {newPayload.map((record, index) => (
            <React.Fragment key={`${record.name}-${index}`}>
              <Col className="chart-record-value justify-content-center" span={24} style={{ color: record?.color }}>
                {record.value === '-' ? '-' : props.valueFormatter(record.value)}
              </Col>
              <Col span={24} className="chart-record-name justify-content-center">
                {props.nameTranslation(record.name)}
              </Col>
            </React.Fragment>
          ))}
          <Divider style={{ margin: '4px 0' }} />
          <Col span={24} className="chart-record-label justify-content-center">{`(${props.labelFormatter(
            props.label
          )})`}</Col>
        </Row>
      </div>
    );
  }

  const mapLatestDataToSeries = (latestData, series, chartId) => {
    const date =
      latestData.dateFrom ?? latestData.date ?? latestData.month ?? latestData.yearQuarter ?? latestData.time;

    // Special handling for casAverageWages chart
    if (chartId === 'casAverageWages') {
      const desiredOrder = ['companyAverageWage', 'averageMale', 'averageFemale', 'sectorAverageWage'];

      // Create a map of series by dataKey for easy lookup
      const seriesMap = {};
      series.forEach(s => {
        seriesMap[s.dataKey] = s;
      });

      // Create latestValues in the desired order
      return desiredOrder
        .map(dataKey => {
          const s = seriesMap[dataKey];
          if (s) {
            const value = latestData[dataKey];
            return {
              date,
              value: value !== undefined && value !== null ? value : '-',
              name: dataKey,
              color: s.fill ?? s.stroke ?? s.color,
            };
          }
          return null;
        })
        .filter(Boolean);
    }

    // Default behavior for other charts
    return series
      .map(({ dataKey, fill, stroke, color }) => {
        // Ensure dataKey exists in latestData
        if (dataKey in latestData) {
          return {
            date,
            value: latestData[dataKey],
            name: dataKey,
            color: fill ?? stroke ?? color,
          };
        }
        return null;
      })
      .filter(Boolean); // Remove nulls for unmatched keys
  };

  const latestValues = mapLatestDataToSeries(props.latestData, props.series, props.id);

  return (
    <div className="recharts-default-tooltip">
      <Row>
        {latestValues.map((record, index) => (
          <React.Fragment key={`${record.name}-${index}`}>
            <Col className="chart-record-value justify-content-center" span={24} style={{ color: record?.color }}>
              {record.value === '-' ? '-' : props.valueFormatter(record.value)}
            </Col>
            <Col span={24} className="chart-record-name justify-content-center">
              {props.nameTranslation(record.name)}
            </Col>
          </React.Fragment>
        ))}
        <Divider style={{ margin: '4px 0' }} />
        <Col span={24} className="chart-record-label justify-content-center">{`(${props.labelFormatter(
          latestValues[0].date
        )})`}</Col>
      </Row>
    </div>
  );
};

export default CustomTooltip;
